<template>
  <div>
    <button
      type="button"
      class="btn btn-middle proxies-btn"
      @click.self="openProxyModal"
    >
      Список прокси
    </button>

    <ParserContent v-for="(site, index) in sites" :key="index" :site="site" />
  </div>
</template>
<script>
import NewProxyModal from "@/components/parsersPage/NewProxyModal";
import { ProxyModalProperties } from "@/utils/modalsProperties";
import ParserContent from "@/components/parsersPage/ParserContent";
import {
  ICE_TRADE,
  GOS_ZAKUPKI,
  BUTB,
  BELOIL,
  BUTB_PPT,
  NAFTAN,
  MINSKTRANS,
  BELARUSKALI,
  BIDMART,
  BELTRANSGAZ,
  PROXY,
  BECLOUD,
  A100,
  BELVEB,
  BUTB_TWS,
  MTS,
} from "@/utils/parsersNames";

export default {
  name: "Parsers",
  data() {
    return {
      sites: [
        {
          name: "proxy",
          source: PROXY,
        },
        {
          name: "goszakupki.by",
          source: GOS_ZAKUPKI,
        },
        {
          name: "zakupki.butb.by",
          source: BUTB,
        },
        {
          name: "icetrade.by",
          source: ICE_TRADE,
        },
        {
          name: "sapsrm.beloil.by",
          source: BELOIL,
        },
        {
          name: "ppt.butb.by",
          source: BUTB_PPT,
        },
        {
          name: "naftan.by",
          source: NAFTAN,
        },
        {
          name: "zakupki.minsktrans.by",
          source: MINSKTRANS,
        },
        {
          name: "belaruskali.by",
          source: BELARUSKALI,
        },
        {
          name: "bidmart.by",
          source: BIDMART,
        },
        {
          name: "belarus-tr.gazprom.ru",
          source: BELTRANSGAZ,
        },
        {
          name: "becloud.by",
          source: BECLOUD,
        },
        {
          name: "a-100development.by",
          source: A100,
        },
        {
          name: "www.belveb.by",
          source: BELVEB,
        },
        {
          name: "tws.butb.by",
          source: BUTB_TWS,
        },
        {
          name: "zakupki.mts.by",
          source: MTS,
        },
      ],
    };
  },
  components: {
    ParserContent,
  },
  methods: {
    openProxyModal() {
      this.$modal.show(NewProxyModal, null, ProxyModalProperties);
    },
  },
};
</script>
<style lang="less" scoped>
.proxies-btn {
  margin-bottom: 24px;
}
</style>
